ui-bank-search-error {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgb(0 0 0 / 60%);
  z-index: 1;

  .errormessage {
    display: block;
    position: relative;
    width: 80vw;
    max-width: 320px;
    top: 33%;
    margin: 0 auto;
    transform: translateY(-50%);
    padding: $sd-spacing-4;
    background-color: $sd-backgroundColor-primary-DEFAULT;

    @include breakpoint($desktop) {
      top: 50%;
    }

    sd-button {
      position: absolute;
      right: $sd-spacing-4;
    }

    p {
      display: block;
      margin-right: $sd-spacing-2;
      padding: $sd-spacing-4;
    }
  }
}
